module.exports = __webpack_public_path__ + "static/img/davis_pictgrid16_800x715.814c395.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid16_800x715.jpg
// module id = Cyp9
// module chunks = 0